import { Component } from '@angular/core';
import { DataService } from '../../../core/services/data/data.service';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-programs',
  standalone: true,
  imports: [ RouterLink , NgClass],
  templateUrl: './programs.component.html',
  styleUrl: './programs.component.scss'
})
export class ProgramsComponent {

  constructor( private DataService : DataService ) {}

  isArabic = false ;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  ngOnInit(): void { 
    this.changeLang() ;
  }
}